import React from 'react';
import { Box, Typography, Button, styled } from '@mui/material';
import { More, TabsIcons } from '../../assets';
import AddIcon from '@mui/icons-material/Add';


const CenteredBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh',
});

const NoRwsales: React.FC = () => {
    const [isAddRwsalesOpen, setIsAddRwsalesOpen] = React.useState(false);

    const handleAddRwsalesOpen = () => {
        setIsAddRwsalesOpen(true);
    };

    const handleAddRwsalesClose = () => {
        setIsAddRwsalesOpen(false);
    };

    return (
        <>
        <CenteredBox>
            <Box sx={{ textAlign: 'center' }}>
                <img src={TabsIcons.UsersIcon} alt="No Rwsales" style={{height : '65px'}} />
                <Typography variant="h5" gutterBottom sx={{fontWeight: 'bold'}}>
                    There are no Rwsales
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<img src={More} alt="Add Builderss" style={{ width: '20px', filter: 'invert(100%)' }} />}
                    sx={{ mt: 1 }}
                    onClick={handleAddRwsalesOpen}  
                >
                    Add New Rwsales
                </Button>
            </Box>
        </CenteredBox>

        </>
    );
};

export default NoRwsales;
